import { getField, updateField } from 'vuex-map-fields'

const getDefaultState = () => ({
  userData: {} // user_id -> DriverTableEntry
})

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    updateField
  },
  getters: {
    getField
  }
}
